import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import PageHero from "@/components/bakery/PageHero";
import { ClipboardArt } from "@/components/bakery/Art";
import { OpnameForm, ManualAdjForm } from "@/components/forms/AdjustmentForms";
import TxnDetailDialog from "@/components/common/TxnDetailDialog";
import { VoidBadge, Tag } from "@/components/common/Chips";
import { EmptyState, Loading, Num } from "@/components/common/ui";
import { useApi } from "@/lib/useApi";
import { fmtDate, shiftDate, todayJkt } from "@/lib/format";
import { tabCls } from "./Kasir";
import { cn } from "@/lib/utils";

function History({ rk, onOpen }) {
  const { data, loading } = useApi("/transactions", { type: "ADJ", date_from: shiftDate(todayJkt(), -30), date_to: todayJkt(), rk });
  if (loading && !data) return <Loading />;
  if (!data?.length) return <EmptyState Art={ClipboardArt} title="Belum ada penyesuaian" desc="30 hari terakhir bersih." testid="adj-empty" />;
  return (
    <div className="grid gap-5 sm:grid-cols-2 xl:grid-cols-3" data-testid="adj-history">
      {data.map((t) => (
        <button key={t.id} onClick={() => onOpen(t.id)} data-testid={`adj-card-${t.txn_no}`}
          className={cn("lift press relative rounded-xl border-2 border-ink bg-white p-4 pt-6 text-left", t.status === "void" && "opacity-60")}>
          <span className="absolute -top-2 left-1/2 h-4 w-16 -translate-x-1/2 rounded bg-ink" />
          <div className="flex items-center justify-between gap-2"><span className="num text-xs font-bold">{t.txn_no}</span><VoidBadge txn={t} /><span className="text-[11px] text-zinc-500">{fmtDate(t.date)}</span></div>
          <div className="mt-2 flex gap-1.5"><Tag tone={t.mode === "opname" ? "ink" : "soft"}>{t.mode === "opname" ? "Stock Opname" : "Manual ±"}</Tag></div>
          <div className="mt-2 text-sm font-medium">{t.reason}</div>
          <ul className="mt-3 space-y-1 border-t border-dashed border-zinc-300 pt-3 text-xs">
            {t.lines.slice(0, 5).map((l, i) => <li key={i} className="flex justify-between gap-2"><span className="truncate">{l.product_name}</span><Num value={l.qty} /></li>)}
            {t.lines.length > 5 && <li className="text-zinc-400">+{t.lines.length - 5} lainnya</li>}
          </ul>
          <div className="mt-2 text-[11px] text-zinc-500">PIC {t.pic_name}</div>
        </button>
      ))}
    </div>
  );
}

export default function Penyesuaian() {
  const { data: products, reload } = useApi("/products");
  const [rk, setRk] = useState(0);
  const [detail, setDetail] = useState(null);
  const saved = () => { reload(); setRk((x) => x + 1); };
  return (
    <div data-testid="penyesuaian-page">
      <PageHero testid="adj-hero" eyebrow="Transaksi · Adjustment" title="Penyesuaian Stok" Art={ClipboardArt}
        desc="Stock opname pagi: isi hitungan fisik, sistem menghitung selisih. Atau koreksi manual ± dengan alasan." />
      <Tabs defaultValue="opname">
        <TabsList className="mb-6 h-auto w-full justify-start gap-2 rounded-none border-b border-zinc-200 bg-transparent p-0">
          <TabsTrigger value="opname" className={tabCls} data-testid="tab-opname">Stock Opname</TabsTrigger>
          <TabsTrigger value="manual" className={tabCls} data-testid="tab-manual-adj">Manual ±</TabsTrigger>
          <TabsTrigger value="history" className={tabCls} data-testid="tab-adj-history">Riwayat</TabsTrigger>
        </TabsList>
        <TabsContent value="opname"><OpnameForm products={products} onSaved={saved} /></TabsContent>
        <TabsContent value="manual"><ManualAdjForm products={products} onSaved={saved} /></TabsContent>
        <TabsContent value="history"><History rk={rk} onOpen={setDetail} /></TabsContent>
      </Tabs>
      <TxnDetailDialog txnId={detail} onClose={() => setDetail(null)} onChanged={() => setRk((x) => x + 1)} />
    </div>
  );
}
